import { h, render } from 'preact'
import App from './containers/App'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const container = document.getElementById('js-projects-overview')

if ( container ) {
  const language = container.dataset.language
  const sub_id = container.dataset.sub
  const slugs = container.dataset.slugs
  render( <App language={language} sub_id={sub_id} branch_slugs={slugs}/>, container )
}



// WEBPACK FOOTER //
// ./src/js/projects/index.js